<template>
  <div>
    <CRow>
      <CCol sm="3">
        <CCard style="background: #bdc6d7">
          <div class="p-2">
            <br />
            <div>
              <h6 class="text-black text-center">List Of Schedule</h6>
              <hr />
              <div style="overflow-x: hidden" class="custom-height-schedule">
                <CRow v-for="item in schedule" v-bind:key="item.Id">
                  <div class="mb-1">
                    <CCol sm="12">
                      <span class="text-black"
                        >{{ item.Start | moment("DD-MM-YYYY") }}
                      </span></CCol
                    >
                    <CCol sm="12">
                      <CBadge color="success">
                        {{ item.SubjectName }}
                      </CBadge></CCol
                    >
                    <CCol sm="12">
                      <CRow>
                        <CCol sm="8">
                          <span class="text-black">
                            <img src="../assets/img/dot.png" class="mr-2" />{{
                              item.Start | moment("HH:mm")
                            }}
                            - {{ item.End | moment("HH:mm") }}</span
                          >
                        </CCol>
                        <CCol sm="4">
                          <div v-if="item.StartDate === TodayDate">
                            <CButton
                              type="button"
                              color="success"
                              @click="CheckAttedance(item)"
                              size="sm"
                            >
                              Attend
                            </CButton>
                          </div>
                          <div v-else>
                            <!-- <CButton
                              type="button"
                              color="success"
                              @click="CheckAttedance(item)"
                            >
                              Attend
                            </CButton> -->
                          </div>
                        </CCol>
                      </CRow>
                    </CCol>
                  </div>
                  <br />
                </CRow>
              </div>
            </div>
          </div>
        </CCard>
      </CCol>
      <CCol sm="9">
        <vue-cal
          class="vuecal--white-theme"
          :events="feedData"
          :time-from="7 * 60"
          events-count-on-year-view="events-count-on-year-view"
          events-on-month-view="short"
          active-view="month"
        >
          <template v-slot:no-event="">No event 👌</template>
        </vue-cal>
      </CCol>
      <CCol sm="12" class="mt-2">
        <CRow>
          <CCol sm="12">
            <CCard class="box-shadow-dashboard">
              <h6 class="ml-3 mt-3"><strong>Offers</strong></h6>
              <p class="ml-3">List of available offer in Pickiddo Platform</p>
              <CCol sm="12" class="mt-2 mb-3">
                <CRow>
                  <CCol
                    v-for="(item, index) in news.slice(0, 4)"
                    v-bind:key="item.Id"
                    sm="3"
                  >
                    <a :href="GoToLink(index)">
                      <div class="text-center p-2">
                        <img
                          style="
                            max-width: 100%;
                            border-radius: 10px;
                            object-fit: cover;
                          "
                          :src="getPic(index)"
                        />
                      </div>
                    </a>
                  </CCol>
                </CRow>
              </CCol>
            </CCard>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CModal size="md" title="Schedule Detail" :show.sync="scheduleModal">
      <div>
        <div class="text-center">
          <h3>
            {{ details.SubjectName }}
          </h3>
          Click Attend button to retrieve online class password.
          <br />Auto deduction in ePay will applied. <br /><br />
         <strong>  By attending this class will deduct credit hour from your ePay account </strong>
            <br /><br />

          <CCard class="p-1 text-left">
            <CRow>
              <CCol sm="6"
                ><strong class="text-left">Time</strong>
                <br />
                <label class="small text-muted text-left"
                  >Teacher Check In Attendance</label
                ></CCol
              >
              <CCol sm="6">
                <strong class="display-5">
                  {{ details.ScheduleDateTime | moment("HH:mm") }}
                </strong>
              </CCol>

              <CCol sm="6"
                ><strong>Date</strong>
                <br />
                <label class="small text-muted text-left"
                  >Date Attendance Taken</label
                ></CCol
              >
              <CCol sm="6">
                <strong class="display-5">
                  {{ details.ScheduleDateTime | moment("DD/MM/YYYY") }}
                </strong>
              </CCol>
              <!-- <CCol sm="12">
              <CButton
                type="button"
                class="bg-gradient text-white"
                block
                @click="OpenAmount(details.ID)"
                >Attend Class</CButton
              >
            </CCol> -->
            </CRow>
          </CCard>
        </div>
      </div>
      <template #footer>
        <CButton
          type="button"
          class="bg-gradient text-white"
          @click="OpenAmount(details.ID)"
          >Attend Class</CButton
        >
      </template>
    </CModal>
    <CModal size="md" title="Note" :show.sync="agreeModalError">
      <div>
        <h3 class="text-center text-danger">Error to Attend Class</h3>
     
      <div class="text-center"> Sorry, you have insufficient amount in ePay.It must be at least 1 Credit Hour in the ePay account to be able join this class. Please TopUp your ePay account.</div>

        <br />
      </div>
    </CModal>

    <CModal size="md" title="Video Conference" :show.sync="videoModal">
      <div>
        <h3 class="text-center">Virtual Class Code</h3>
        <br />
        Use this code/password to start your online class
        <ul>
          <li>Open your zoom/ / google meet</li>
          <li>Enter this password / code into given box</li>
          <li>Start Join Class</li>
        </ul>
        <CCol sm="12">
          <div class="text-left">
            <CInput type="text" value="77322344332" v-model="video.MeetingId" />

            Code/Password <br />
            <CInput type="text" value="" v-model="video.Password" />

            Link Zoom<br />

            <a :href="video.VcLink">Open Link</a>
            <br />
          </div>
        </CCol>
      </div>
    </CModal>
  </div>
</template>



<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgCard.png";
import VCalendar from "v-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    VCalendar,
    VueCal,
  },
  data() {
    return {
      backgroundUrl,
      user: {},
      news: [],
      schedule: [],
      CreationDate: "",
      scheduleModal: false,
      details: {},
      size: "",
      agreeModal: false,
      videoModal: false,
      video: {},
      agreeModalError: false,
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetScheduleStudent();
      this.GetNews();
      this.GetScheduleDetail();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    TodayDate: {
      get: function () {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        var yyyy = today.getFullYear();

        today = yyyy + "-" + mm + "-" + dd;
        console.log(today + "test");
        return today;
      },
    },
  },

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            console.log(":testing" + this.user.id);
            this.GetScheduleStudent(this.user.id);
            this.GetScheduleDetail();
          }
        });
    },
    CheckAttedance(item) {
      this.scheduleID = item.ID;
      this.GetScheduleDetail(this.scheduleID);
      this.scheduleModal = true;
    },
    OpenAmount(ID) {
     // this.agreeModal = true;
      this.scheduleModal = false;
      this.scheduleID = ID;

     this.CheckWallet(this.scheduleID);
    },
    GetScheduleStudent() {
      this.$API
        .get(this.$ScheduleStudentWeb + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.schedule = response.data;

            var combinedrates = [];
            for (let i in this.schedule) {
              let item = this.schedule[i];

              combinedrates.push({
                start: item.start,
                end: item.end,
                title: item.title,
                class: item.ThemeColor,
                content:
                  '<span class="material-icons">video_camera_back</span>',
              });
            }

            this.feedData = combinedrates;
            // this.feedData = feedDatas;

            console.log("data:" + this.feedData);
          }
        });
    },
    GetNews() {
      this.$API.get(this.$News, { withCredentials: true }).then((response) => {
        if (response.status == 200 && response.data != null) {
          this.news = response.data;
          this.getPic(this.news.urlImage);
          this.GoToLink(this.news.Url);
        }
      });
    },

    GetScheduleDetail(scheduleID) {
      return this.$API
        .get(this.$EditSchedule + "?scheduleID=" + scheduleID)
        .then((response) => {
          if (response.status == 200) {
            this.details = response.data;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            this.Error = true;
            this.Message = error;
          }
        });
    },

    getPic(index) {
      return this.news[index].urlImage;
    },
    GoToLink(index) {
      return this.news[index].Url;
    },
    async CheckWallet(scheduleID) {
      console.log(scheduleID + "testing");
      const formData = new FormData();

      formData.append("userId", this.user.id);
      formData.append("scheduleId", scheduleID);

      return this.$API
        .post(this.$CheckEwalletAmount, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data >= 0) {
              this.GetVideoDetail(scheduleID);
             // this.videoModal = true;
             // this.agreeModal = false;
            } else {
              this.agreeModalError = true;
            }
          } else {
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
            this.ErrorMessageNotComplete = true;
          }
        });
    },
    GetVideoDetail(scheduleID) {
      this.videoModal = true;
      return this.$API
        .get(this.$VideoConference + "?scheduleID=" + scheduleID)
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.video = response.data;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            this.Error = true;
            this.Message = error;
          }
        });
    },
  },
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");

.vuecal__time-column .vuecal__time-cell {
  color: #999;
  text-align: right;
  padding-right: 2px;
  font-size: 0.9em;
  height: 90px;
}
</style>



